<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="header">
        <span>分类标签</span>
      </div>
      <div class="body">
        <div v-for="(item,index) in content" :key="index" class="label">
          <p class="title">{{item.name}}</p>
          <ul>
            <li v-for="(val,key) in item.son_list" :key="key">
              <i @click="val.selected = !val.selected" :class="{on: val.selected}"></i>
              <span>{{val.name}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer">
        <p :class="{btn: true, green: true}" @click="confirm()">确定</p>
        <p class="btn" @click="cancel()">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'Label',
  data() {
    return {
      show: true,
      content: [],
      maxlength: 60,
      r: null,
      disabled: false,
      startEmpty: false
    }
  },
  methods: {
    open(content, r) {
      window.document.body.style.overflowY = 'hidden'
      this.content = content
      this.r = r
      this.show = true
    },
    close() {
      window.document.body.style.overflowY = 'auto'
      this.show = false
    },
    async confirm() {
      this.r(this.content)
      this.close()
    },
    cancel() {
      this.r(null)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    height: 550px;
    width: 826px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 30px;
    .header {
      height: 34px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      color: #050F0F;
    }
    .body {
      margin: 30px 0 20px;
      flex: 1;
      overflow-y: auto;
      position: relative;

      /*滚动条样式*/
      &::-webkit-scrollbar {/*滚动条整体样式*/
          width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
          height: 2px;
      }
      &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
          -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
          background: rgba(0,0,0,0.1);
      }
      &::-webkit-scrollbar-track {/*滚动条里面轨道*/
          // box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
          // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
          border-radius: 0;
          background: transparent;
      }
      
      .label {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        &:nth-of-type(1) {
          margin-top: 0;
        }

        .title {
          font-size: 16px;
          line-height: 22px;
          color: #050F0F;
          margin-bottom: 20px;
        }

        ul {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          li {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 25%;
            // margin-right: 120px;
            margin-bottom: 14px;

            // &:nth-of-type(4n+4) {
            //   margin-right: 0;
            // }

            i {
              display: block;
              min-width: 14px;
              min-height: 14px;
              border-radius: 2px;
              border: 1px solid #B9C3C3;
              box-sizing: border-box;
              margin-right: 10px;
              user-select: none;
              cursor: pointer;
              border-radius: 4px;
              
            
              &.on {
                background: url('../../assets/img/interview/checkerOn.svg') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                border: 1px solid @green;
                background-color: @green;
              }
            }

            span {
              color: #050F0F;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }
    .footer {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .close {
      cursor: pointer;
    }
    .btn {
      background-color: @dateColor;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      color: #fff;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 40px;
      color: #fff;
      background-color: @green;
    }
    .disabled {
      cursor: not-allowed;
      color: #fff !important;
      background-color: @dateColor !important;
    }
  }
</style>
